import { apiDelete, apiPost } from '@/services/api/http'

export interface FcmRegisterInput {
  token: string
  platform?: string
  userAgent?: string
}

export interface FcmDevice {
  id: string
  userId: string
  token: string
  platform: string | null
  userAgent: string | null
  createdAt: string
  updatedAt: string
  lastSeenAt: string
}

export interface FcmRegisterResult {
  registered: boolean
  device?: FcmDevice
  /** Present when `registered` is false because the server has confirmed
   * this exact token is dead (Firebase reported it not-registered). */
  status?: 'token_invalid'
  regenerate?: boolean
}

export interface FcmUnregisterResult {
  unregistered: boolean
  removed: boolean
}

/** FCM token ↔ backend — separate from legacy VAPID push-subscribe. */
export const fcmTokenService = {
  register: (input: FcmRegisterInput): Promise<FcmRegisterResult> =>
    apiPost<FcmRegisterResult>('/notifications/fcm-token', input),

  unregister: (token: string): Promise<FcmUnregisterResult> =>
    apiDelete<FcmUnregisterResult>('/notifications/fcm-token', { data: { token } }),
}
